import React, {Component} from 'react';
import {connect} from 'react-redux';
import {RootState, selectors} from '../store';
import {
  IonPopover,
  IonIcon,
  IonSelect,
  IonSelectOption,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonMenuButton,
  IonBackButton,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonDatetime,
  IonCard,
  IonRow,
  IonCol,
  IonInput,
  IonCardHeader,
  IonCardContent,
  IonCardTitle,
  IonCardSubtitle,
  IonTitle
} from '@ionic/react';
import './Studentmanagement.css';
import {RouteComponentProps} from "react-router";
import {AuthComponent} from "./_/AuthComponent";
import _ from "../_";
import {ApiService} from "../_/ApiService";
import {Static} from "../_/Static";
import {StaticEvent} from "../_/StaticEvent";
import Moment from 'react-moment';
import {calendar, pin} from 'ionicons/icons';
import {logIn} from "../store/user/actions";
import {BaseComponent} from "./_/BaseComponent";

type Props = RouteComponentProps<{}> & ReturnType<typeof mapStateToProps>

type State = {
  showPopover: boolean,
  showPopoverEvent: null | MouseEvent
}

class ForgotPassword extends BaseComponent<Props, State> {
  static RoutePathname = /^\/forgotpassword/gi;

  constructor(props: Props) {
    super(props);

    this.state = {
      showPopover: false,
      showPopoverEvent: null
    };
  }

  presentPopover = (e: MouseEvent) => {
    this.setState(() => ({
      showPopover: true,
      showPopoverEvent: e
    }));
  }

  dismissPopover = () => {
    this.setState(() => ({
      'showPopover': false,
      'showPopoverEvent': null
    }));
  }

  handleInputChange(e) {
    // @ts-ignore
    this.setState({
      [e.target.name]: e.target.value
    });
  }


  forgetPassword(e: any) {
    e.preventDefault();

    // @ts-ignore
    const {email} = this.state;

    // @ts-ignore
    //const {dispatch} = this.props;
    //dispatch(userActions.login(username, password));

    if (email) {
      // WAITING SCREEN
      StaticEvent.LoadingEvent.next(true);

      // POST
      let postData = {
        email: email,
      };
      const postUrl = ApiService.urlMapping('~/api/1/_forgotpassword');
      Static.apiService
        .post(postUrl, postData)
        .subscribe(async (res) => {
            // CLOSE WAITING SCREEN
            StaticEvent.LoadingEvent.next(false);

            let data = res.data;
            _.debugManager.log(data);

            let error = data.error || null;
            let result = error == null;

            if (result) { // SUCEESS

              // let t_customer = data.payload.userEntity;
              // let serverSessionId = data.payload.SessionID;
              //
              // await Static.storageService.setLoggedAsync(serverSessionId, JSON.stringify(t_customer));

              //alert('已寄出認證信，請查閱信箱')

              // @ts-ignore
              this.props.history.push('/SendVerify')

              //window.location = '/f1';
              //history.pushState({}, 'page 2', '/f1');
              //await _.sharedStateManager.rootNav.setRoot(askMeIndex, {});
              //await this.viewCtrl.dismiss();

            } else {
              alert(error.message);
              // const controller: any = document.querySelector('ion-toast-controller');
              // let msg = await controller.create({
              //   message: error.message,
              //   duration: 2000,
              //   position: 'top'
              // });
              // await msg.present();
            }
          }, async (err) => {
            // CLOSE WAITING SCREEN
            StaticEvent.LoadingEvent.next(false);
            _.debugManager.warn(err);
            alert('網路連線有問題');
          }
        );
    }
  }


  render() {
    return (
      <>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonBackButton defaultHref="/" onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                this.props.history.goBack();
              }} text="返回"/>
            </IonButtons>
            <IonTitle>忘記密碼</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent className="stmgr" color="medium" scroll-y="false">
          <div className="panelpage">
            <div className="itembox">
              <IonList no-lines>
                <IonItem>
                  <IonLabel position="floating">驗證帳號</IonLabel>
                  <IonInput
                    name="email"
                    onInput={(e: any) => this.handleInputChange(e)}
                    placeholder="請輸入報名時填寫的E-Mail"
                    type="text" required>
                  </IonInput>
                </IonItem>
              </IonList>
              <IonRow responsive-sm>
                <IonCol>
                  <IonButton expand="block" color="primary" type="submit" onClick={(e) => this.forgetPassword(e)}>
                    送出
                  </IonButton>
                </IonCol>
              </IonRow>
            </div>
          </div>
        </IonContent>
      </>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  conferenceDate: selectors.sessions.conferenceStart(state.sessions),
});

export default connect(
  mapStateToProps
)(ForgotPassword);
